import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import WhiteLabelOrganizationDeleteCard from './organizationDetails/WhiteLabelOrganizationDeleteCard';
import WhiteLabelOrganizationSummaryCard from './organizationDetails/WhiteLabelOrganizationSummaryCard';
import WhiteLabelOrganizationUsersCard from './organizationDetails/WhiteLabelOrganizationUsersCard';
import WhiteLabelOrganizationWorkshopsCard from './organizationDetails/WhiteLabelOrganizationWorkshopsCard';

const WhiteLabelOrganizationDetailsPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const whiteLabelOrganizationId = Number(id);
  const navigate = useNavigate();

  if (isNaN(whiteLabelOrganizationId)) {
    navigate('/404', { replace: true });
    return null;
  }
  return (
    <ContentLayout>
      <PageMetatags title={t('pages:whitelabel_organizations.details_page.meta_title')} />
      <WhiteLabelOrganizationSummaryCard whiteLabelOrganizationId={whiteLabelOrganizationId} />
      <WhiteLabelOrganizationUsersCard whiteLabelOrganizationId={whiteLabelOrganizationId} />
      <WhiteLabelOrganizationWorkshopsCard whiteLabelOrganizationId={whiteLabelOrganizationId} />
      <WhiteLabelOrganizationDeleteCard whiteLabelOrganizationId={whiteLabelOrganizationId} />
    </ContentLayout>
  );
};

export default WhiteLabelOrganizationDetailsPage;
